module.exports = __webpack_public_path__ + "main/assets/public/map-embed/map-marker.122106b3b1f34bd1.png";